import React, { useEffect, useRef } from "react";
import { ArrowUpRight } from "lucide-react";

/* ===============================
   SERVICES DATA (CDN SAFE)
================================ */
const services = [
  {
    title: "Bulk FMCG Supply",
    image:
      "https://images.unsplash.com/photo-1580910051074-7f6aa3c7b2e8?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Cold Chain Logistics",
    image:
      "https://images.unsplash.com/photo-1581092335397-9583eb92d232?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Warehouse Distribution",
    image:
      "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "Retail Partner Supply",
    image:
      "https://images.unsplash.com/photo-1601598851547-4302969d0614?auto=format&fit=crop&w=1200&q=80",
  },
  {
    title: "New Outlet Onboarding",
    image:
      "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1200&q=80",
  },
];

/* ===============================
   COMPONENT
================================ */
export default function ServicesSection() {
  const scrollRef = useRef(null);

  /* ===============================
     AUTO SCROLL (MOBILE ONLY)
  ================================ */
  useEffect(() => {
    const container = scrollRef.current;
    if (!container) return;

    let intervalId;

    const startAutoScroll = () => {
      intervalId = setInterval(() => {
        if (window.innerWidth >= 768) return;

        container.scrollLeft += 1;

        if (
          container.scrollLeft + container.clientWidth >=
          container.scrollWidth
        ) {
          container.scrollLeft = 0;
        }
      }, 20);
    };

    startAutoScroll();

    container.addEventListener("mouseenter", () => clearInterval(intervalId));
    container.addEventListener("mouseleave", startAutoScroll);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <section className="bg-[#FBF7F4] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        
        {/* ================= HEADER ================= */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 mb-12">
          <div>
            <p className="text-sm tracking-wide text-red-600 mb-3">
              / Services We Offer
            </p>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold text-[#1C0F0B] leading-tight">
              Certified <br /> Excellence
            </h2>
          </div>

          <div className="flex flex-col justify-center">
            <p className="text-gray-600 max-w-md mb-6">
              From bulk procurement and logistics to retail enablement, Daily Go
              delivers scalable, dependable B2B wholesale solutions.
            </p>

            <div className="flex items-center gap-6">
              <a
                href="https://dailygolive.in/ServiceIndex"
                className="text-red-600 font-medium inline-flex items-center gap-1 hover:underline"
              >
                View All Services <ArrowUpRight size={18} />
              </a>
              <a
                href="https://dailygolive.in/GetInTouchIndex"
                className="text-red-600 font-medium inline-flex items-center gap-1 hover:underline"
              >
                Call For Booking <ArrowUpRight size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* ================= CARDS ================= */}
        <div
          ref={scrollRef}
          className="
            flex gap-6 overflow-x-auto pb-4 scroll-smooth
            md:grid md:grid-cols-2
            lg:grid-cols-5
            md:overflow-visible
          "
        >
          {services.map((service, index) => (
            <div
              key={index}
              className="
                min-w-[260px] md:min-w-0
                relative rounded-3xl overflow-hidden
                group cursor-pointer
              "
            >
              {/* IMAGE */}
              <img
                src={service.image}
                alt={service.title}
                loading="lazy"
                onError={(e) => {
                  e.currentTarget.src =
                    "https://images.unsplash.com/photo-1604014237800-1c9102c219da?auto=format&fit=crop&w=1200&q=80";
                }}
                className="
                  w-full h-[340px] object-cover
                  grayscale group-hover:grayscale-0
                  transition duration-500
                "
              />

              {/* OVERLAY */}
              <div className="absolute inset-0 bg-black/30"></div>

              {/* TITLE */}
              <div className="absolute bottom-5 left-5 right-5 flex items-center justify-between">
                <h3 className="text-white text-lg font-medium">
                  {service.title}
                </h3>

                <span className="
                  w-10 h-10 rounded-full
                  bg-[#5A1D14] flex items-center justify-center
                  group-hover:bg-red-600 transition
                ">
                  <ArrowUpRight className="text-white" size={18} />
                </span>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
